// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ApkLoanKTAFinancial2Service = {};
 
 
ApkLoanKTAFinancial2Service.getApkLoanKTAFinancial2Service = function (data) { 
  
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      "/ApkLoanKTAFinancial2/getadd?pageSize=" +
      data.pageSize +
      "&pageIndex=" +
      decrementIndex + 
      "&prospectid=" +
      data?.prospectid,
    method: "get",
  });
};
 
ApkLoanKTAFinancial2Service.getEditApkLoanKTAFinancial2Service = function (data) { 
  
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      "/ApkLoanKTAFinancial2/getedit?pageSize=" +
      data.pageSize +
      "&pageIndex=" +
      decrementIndex + 
      "&prospectid=" +
      data?.prospectid,
    method: "get",
  });
};


ApkLoanKTAFinancial2Service.postApkLoanKTAFinancial2Service = function (data) {
  
   return lossClient({
     url: `/ApkLoanKTAFinancial2/add`,
     method: "post",
     headers: {},
     data: data,
   });
 };

ApkLoanKTAFinancial2Service.putApkLoanKTAFinancial2Service = function (data) {
  
   return lossClient({
     url: `/ApkLoanKTAFinancial2/edit`,
     method: "put",
     headers: {
      "x-requestId": data.id
     },
     data: data.data,
   });
 };
 
 
 
 
 
 

export default ApkLoanKTAFinancial2Service;
